module.exports = __webpack_public_path__ + "static/media/peroni_formati_1.ff3488e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/peroni_formati_1.jpg
// module id = 808
// module chunks = 0